import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import PageNotFound from '~/commons/components/PageNotFound.jsx';
import {
  Nav,
} from './layout';
import {
  RouteArticles,
  RouteAssignments,
  RouteSite,
  RouteAnnouncements,
  RouteShares,
  RouteSchools,
  RouteLevels,
  RouteReports,
  RouteUsers,
  RouteDashboards,
  RouteSetting,
  RouteTrainings,
} from './routes';

import { env } from '../config';

const Admin = () => (
  <div className="container-fluid h-100 bg-lighter">
    <div className="row h-100">
      <Router>
        <Nav />
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/admin" exact>
                <Redirect to={
                    env.user.roles.includes('admin')
                      ? '/admin/users/students'
                      : '/admin/dashboard'
                } />
              </Route>
              <Route path="/admin/dashboard">
                <RouteDashboards />
              </Route>
              <Route path="/admin/users">
                <RouteUsers />
              </Route>
              <Route path="/admin/schools">
                <RouteSchools />
              </Route>
              <Route path="/admin/articles">
                <RouteArticles />
              </Route>
              <Route path="/admin/assignments">
                <RouteAssignments />
              </Route>
               <Route path="/admin/trainings">
                <RouteTrainings />
              </Route>
              <Route path="/admin/setting">
                <RouteSetting />
              </Route>
              <Route path="/admin/site">
                <RouteSite />
              </Route>
              <Route path="/admin/announcements">
                <RouteAnnouncements />
              </Route>
              <Route path="/admin/shares">
                <RouteShares />
              </Route>
              <Route path="/admin/levels">
                <RouteLevels />
              </Route>
              <Route path="/admin/reports">
                <RouteReports />
              </Route>
              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
);

export default Admin;
